var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"d-flex justify-center align-center base-badge-container",class:_vm.bgColor,attrs:{"height":_vm.size,"min-width":_vm.size,"rounded":_vm.rounded},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{class:[..._setup.classes, _vm.contentClass]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }